require('./lbDatePicker.scss');

const lbDatePicker = angular.module('app.lbDatePicker', [
  'pickadate'
]);

lbDatePicker.component('lbDatePicker', {
  bindings: {
    settings: '<'
  },
  controllerAs: 'vm',
  controller: ['$document', '$timeout', 'moment', '$filter', controller],
  template: require('./lbDatePicker.html')
});

function controller($document, $timeout, moment, $filter) {
  let l = document.getElementById('lbDatePickerClose');
  l.focus();


  let vm = this;

  vm.dateFormat = $filter('translate')('dates.dateFormat');
  const DATE_FORMAT_UPPER = $filter('translate')('dates.DateFormat');

  vm.dateSelected = dateSelected;
  vm.closeDatePicker = closeDatePicker;
  vm.date = vm.settings.defaultDate;

  $document.on('keydown', function (e) {
    keyDown(e);
  });

  function dateSelected(date) {
    vm.settings.input.focus();
    vm.settings.input.selectionEnd = vm.settings.input.selectionStart;

    $timeout(() => {
      $document.unbind('keydown');

      vm.settings.callBack({
        target: vm.settings.parent,
        date: date
      });
    }, 0);
  }

  function closeDatePicker() {
    $document.unbind('keydown');
    vm.settings.callBack(null, vm.settings.input);
  }

  function keyDown(e) {
    e.preventDefault();

    switch (e.keyCode) {
      case 39: // Right arrow key
        $timeout(()=> {
          vm.date = moment(vm.date, DATE_FORMAT_UPPER).add(1, 'd').format(DATE_FORMAT_UPPER);
        }, 0);
        break;

      case 40: // Down arrow key
        $timeout(()=> {
          vm.date = moment(vm.date, DATE_FORMAT_UPPER).add(7, 'd').format(DATE_FORMAT_UPPER);
        }, 0);
        break;

      case 37: // Left arrow key
        $timeout(()=> {
          if (vm.date != vm.settings.minDate)
            vm.date = moment(vm.date, DATE_FORMAT_UPPER).subtract(1, 'd').format(DATE_FORMAT_UPPER);
        }, 0);
        break;

      case 38: // Up arrow key
        $timeout(()=> {
          if (vm.date != vm.settings.minDate)
            vm.date = moment(vm.date, DATE_FORMAT_UPPER).subtract(7, 'd').format(DATE_FORMAT_UPPER);
        }, 0);
        break;

      case 13: // Enter key
        $timeout(()=> {
          dateSelected(moment(vm.date, DATE_FORMAT_UPPER));
        }, 0);
        break;

      case 9: // Tab key
        $timeout(()=> {
          dateSelected(moment(vm.date, DATE_FORMAT_UPPER));
        }, 0);
        break;


      default:
        console.warn('keyCode not assigned');
    }
  }

}

export default lbDatePicker;


// WEBPACK FOOTER //
// ./src/components/lbDatePicker/lbDatePicker.js